import { TabBookingAbstract } from './tabBookingAbstract'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as OverseaAgentGrade from '@/class/cargo/model/parameters/OverseaAgentGrade'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaExportUtils } from '@/class/cargo/model/utils/SeaExportUtils'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SopEmailReceiver } from '@/class/model/booking/SopEmailReceiver'
import { TruckingInfo } from '@/class/model/booking/TruckingInfo'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import { SopPushConfig } from '@/class/model/sys/SopPushConfig'
import { OverseaAgent } from '@/class/model/sys/OverseaAgent'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { ClosingAccount } from '@/class/model/act/ClosingAccount'
import { canCreateByCreditInfoDetail, checkCreditInfo } from '@/api/partner/creditInfo'
import { getUserDefaultDepartment } from '@/api/user'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData, getObjectByCache } from '@/utils/basicDataCache'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import StrUtils from '@/utils/StrUtils'
import { dateCompareYMD, ensureExecuteSuccess, multiply } from '@/utils/commonUtil'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import DateUtils from '@/utils/dateUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { sortByMultiField } from '@/utils'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { getContractsByCompanyUuids } from '@/api/partner/contract'
import { dateCompare } from '@/utils/commonUtil'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { SeaEQ } from '@/class/model/booking/SeaEQ'
import { AutoContaninerFactory } from '@/class/cargo/model/utils/AutoContaninerFactory'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { findBusinessDocument } from '@/api/seaExport/businessDocument'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  batchAddJob,
  batchDeleteJob,
  batchRemoveJob,
  checkJobForShared,
  getSeaExportJobByUuid
} from '@/api/seaExport/seaExportJob'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import moment from 'moment'
import { CHARGE_SOURCE_SPLIT } from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { shouldPreserveCopiedCarryingCmp, shouldPreserveCopiedWarehouseCmp } from '../seaBookingCopyConfig'

export class TabBuyerConsoleFclBookingMasterPM extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.addrPM = null // 提单地址
    this.chargeWeightCalculationMode = 0 // 录入费用计费数量取值类型
    this.trustFromEditSales = false // 交叉委托编辑销售
    this.isSpecifiedSalesBusiness = false // 是否启用合作伙伴对应的服务人员设置(多销售模式)
    this.customerLockInCargoSource = false // 根据客户锁定揽货类型
    this.sEUseDischargingPort5Code = false // 装箱单是否使用卸港5字码
    this.refSelDesignationAgent = false // 选择目的港代理时是否自动刷新指定货代理
    // this.hblNoConfig = Config.configMap['SEHblNoPattern'] // 海运HBL单号生成规则
    this.billChargeFlag = false // 费用是否做过账单
    this.mblDoc = null // MBL CargoDoc
    this.isClearDestinationAgent = false
    this.dischargingPortIsDirty = true
    this.visibleFreightTerm = false // 是否显示主单运输条款
    this.isWithinCloseAccountDate = false // 关账控制
    this.isCrossTenant = false // 是否跨tenant委托
    this.isShowAcPaymentPlaceBL = false // 是否显示主单付款地点
    this.prompt1TitleWindow = null // 抄录
    this.hsCodeSearchWindow = null // 抄录HsCode
    this.customerContactWindow = null // 联系人信息
    this.selectSurchargeTermsWindow = null // 付费条款
    this.sycSCN = false // 是否同步收发通代码到基本页签
    this.sopWindow = null
    this.sopConfigOpen = false // SOP总开关
    this.salesUser = null // 当前销售
    this.creditOpen = false // 是否开启信控
    this.branchOfficeCheck = false
    this.salesOfficeCheck = false // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
    this.destinationAgentArray = [] // 目的港代理下拉框数据源
    this.designationAgentArray = [] // 指定货代理下拉框数据源
    this.bookingAgentArray = [] // 订舱代理下拉框数据源
    this.formInitialValue = {} // 表单的初始值（用于判断表单字段是否被修改）
    this.loadingAgentIdArray = [] // 起运港代理下拉框数据源
  }
  get lclslaveEnabled() {
    return this.view.lclslaveEnabled
  }
  set lclslaveEnabled(lclslaveEnabled) {
    this.view.lclslaveEnabled = lclslaveEnabled
  }
  get salesOfficeCheck() {
    return this.view.salesOfficeCheck
  }
  set salesOfficeCheck(salesOfficeCheck) {
    this.view.salesOfficeCheck = salesOfficeCheck
  }
  get branchOfficeCheck() {
    return this.view.branchOfficeCheck
  }
  set branchOfficeCheck(branchOfficeCheck) {
    this.view.branchOfficeCheck = branchOfficeCheck
  }
  get creditOpen() {
    return this.view.creditOpen
  }
  set creditOpen(creditOpen) {
    this.view.creditOpen = creditOpen
  }
  get sopConfigOpen() {
    return this.view.sopConfigOpen
  }
  set sopConfigOpen(sopConfigOpen) {
    this.view.sopConfigOpen = sopConfigOpen
  }
  get job() {
    return this.view.form
  }
  set job(job) {
    this.view.form = job
  }
  init() {
    this.trustFromEditSales = Number(this.config.get('TrustFromEditSales')) === 1
    this.chargeWeightCalculationMode = ChargeUtils.getChargeWeightValueType(true)
    this.isSpecifiedSalesBusiness = Number(this.config.get('IsSpecifiedSalesBusiness')) === 1
    this.customerLockInCargoSource = Number(this.config.get('CustomerLockInCargoSource')) === 1
    this.sEUseDischargingPort5Code = Number(this.config.get('SEUseDischargingPort5Code')) === 1
    this.refSelDesignationAgent = Number(this.config.get('refSelDesignationAgent')) === 1
    this.canChangeSalesOfJob = Number(this.config.get('canChangeSalesOfJob')) === 1
    this.isJoinCarrierBookingAgent = Number(this.config.get('CarrierBookingAgentJoin')) === 1
    this.isJoinPortDestinationAgent = Number(this.config.get('PortDestinationAgentJoin')) === 1
    this.sycSCN = parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    getSpecificBasicData(basicCacheKeys.basic_data_CutomJobType).then(data => {
      this.cutomJobTypeList = data
    })
    getSpecificBasicData(basicCacheKeys.basic_data_Packing).then(data => {
      this.packingList = data
    })
    // 起运港代理下拉框赋值
    Company.getCmpIdxByLocal({ branchId: this.context.office.officeId }).then(res => {
      this.loadingAgentIdArray = res
    })
  }
  changeJob() {
    if (this.job.uuid) {
      this.loadForBookingResultHandler()
      this.loadPushHistoryLogsHandler()
    } else {
      this.loadForBookingResultHandler()
    }
    this.formInitialValue = { ...this.job }
  }
  fillView() {
    const job = this.job
    if (!job.uuid) {
      this.paymentTermMBL_Change(job.paymentTermMBL)
      this.loadOverseaAgentDetail()
      this.carrierAgentSyncLoading()
      this.seaEqDateCl()
      JobUtils.matchUserPortConfig(this.view, job)
      JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData, true)
    } else {
      JobUtils.matchUserPortConfig(this.view, job, false, null, { keepOriginValue: true })
    }
    this.warehouseNoeditableCl()
    this.viewOtherChanged()
    this.loadSalesDptOffceChanged()
    this.loadOverseaPortDestinationAgent()
    this.lclslaveEnabledCl()
    this.checkVesselLine()
    this.checkWithinClosingAccountDate()
    this.checkIsCrossTenant()
    this.ETDEditChange()
    this.sopConfig()
    if (!job.uuid && this.view.action === 'copy') {
      if (job.csr > 0) {
        this.view.$nextTick(() => {
          this.view.$refs.csr.executeAfterLoad(data => {
            if (JobUtils.checkUserRolePrivilege(data, job.csr)) {
              job.csr = 0
              job.csrDepartment = 0
            }
          })
        })
      }
      if (job.dc > 0) {
        this.view.$nextTick(() => {
          this.view.$refs.dc.executeAfterLoad(data => {
            if (JobUtils.checkUserRolePrivilege(data, job.dc)) {
              job.dc = 0
              job.dcDepartment = 0
            }
          })
        })
      }
      // 复制时带海外客服逻辑
      if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) { // 指定货
        this.loadOverseaAgentUserByLob(job.designationAgent) // 指定货确定海外客服
      } else {
        this.loadOverseaAgentUserByLob(job.destinationAgent) // 目的港代理确定海外客服
      }
      this.setPlannerChange()
    }
    this.loadCompanyOffice()
  }
  checkCredit() {
    this.view.showWarningImageA = false
    this.view.showWarningImageB = false
    this.view.showWarningImageC = false
    if (this.view.creditOpen) {
      const job = this.job
      // 委托单位
      if (job && job.customerId > 0) {
        this.checkCreditByCompany(job.customerId, 1)
      }
      // 指定货代理
      if (job && job.designationAgent > 0) {
        this.checkCreditByCompany(job.designationAgent, 2)
      }
      // 目的港代理
      if (job && job.destinationAgent > 0) {
        this.checkCreditByCompany(job.destinationAgent, 3)
      }
    }
  }
  /**
   * 判断海外客服是否有效
   */
  isActiveOverSeaOp() {
    const job = this.job
    let flag = false
    if (job && job.overseaOp) {
      const user = this.userList.find(p => p.userId === job.overseaOp)
      if (user && user.active) {
        flag = true
      }
    }
    return flag
  }
  async fillModel() {
    const isInsidePacking = parseInt(this.config.get('seaInsidePacking'))
    const billOfLadingSynMode = parseInt(this.config.get('BillOfLadingSynMode'))
    const seaCargoMark = parseInt(this.config.get('seaCargoMark'))
    const mergeHblData = parseInt(this.config.get('mergeHblData'))
    const seaCargoEnglishName = parseInt(this.config.get('seaCargoEnglishName'))
    const job = this.job
    const oldJob = this.formInitialValue
    if (job.shipperId && !job.shippeerCode) {
      const cmp = this.companyList.find(p => p.cmpIdx === job.shipperId)
      if (cmp) {
        job.shipperCode = cmp.shortName
      }
    }
    if (job.consigneeId && !job.consigneeCode) {
      const cmp = this.companyList.find(p => p.cmpIdx === job.consigneeId)
      if (cmp) {
        job.consigneeCode = cmp.shortName
      }
    }
    if (job.notifyId && !job.notifyCode) {
      const cmp = this.companyList.find(p => p.cmpIdx === job.notifyId)
      if (cmp) {
        job.notifyCode = cmp.shortName
      }
    }
    // 同步HBL相关信息
    const hblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.HBL, true)
    if (hblDoc) {
      // hblDoc.paymentPlaceBL = job.paymentPlaceHBL
      hblDoc.packing = job.packing
      const hblDoc2 = new SeaExportJob(job).getCargoDoc(CargoDocConsts.HBL2)
      if (hblDoc2) {
        hblDoc2.paymentPlaceBL = hblDoc.paymentPlaceBL
      }
      const oldMark = hblDoc.mark
      const oldCargoEnglishName = hblDoc.cargoEnglishName
      if (hblDoc.state !== 2) {
        if (!hblDoc.uuid || !hblDoc.mark || ([1, 2].indexOf(seaCargoMark) > -1 && job.mark !== oldJob.mark)) { hblDoc.mark = job.mark }
        if (!hblDoc.uuid || !hblDoc.cargoEnglishName || [1, 2].indexOf(seaCargoEnglishName) > -1 && job.cargoEnglishName !== oldJob.cargoEnglishName) {
          hblDoc.cargoEnglishName = job.cargoEnglishName
        }
      }
      // CARGO-9437 复制业务，能把提单页签的品名和唛头都复制下来
      if (job.signHBL && this.view.action === 'copy') {
        hblDoc.mark = oldMark
        hblDoc.cargoEnglishName = oldCargoEnglishName
      }
      if (job.jobState === -1) {
        hblDoc.mark = ''
        hblDoc.cargoEnglishName = ''
      }
      if (!hblDoc.uuid || !hblDoc.cargoManifestName) { hblDoc.cargoManifestName = job.cargoEnglishName }
      if (!hblDoc.uuid || !hblDoc.quantitySum || billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
        const packing = this.packingList.find(p => p.code === this.job.packing)
        hblDoc.quantitySum = StrUtils.jsdx(job.quantityActual, packing ? packing.name : this.job.packing)
      }
      if (isInsidePacking === 1) {
        hblDoc.insidePacking = job.insidePacking
      }
      hblDoc.containerSum = ContainerUtil.getSeaeqNumberStr(job)
      if (!hblDoc.uuid) {
        if (job.jobState !== -1 && this.view.action !== 'copy') { // 订舱预审不同步收发通
          new SeaExportJob(job).copySCNotifyToDoc(new SeaCargoDoc(hblDoc))
        }
        // if (job.containerLoadType !== 'BB') {
        //   hblDoc.container = SeaExportUtils.getContainerDesc(job, false)
        // } else {
        //   hblDoc.container = SeaExportUtils.getContainerDesc(job, hblDoc.printParam3)
        // }
      }
    }
    // 同步MBL相关信息
    const mblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.MBL, true)
    if (mblDoc) {
      const oldMark = mblDoc.mark
      const oldCargoEnglishName = mblDoc.cargoEnglishName
      if (!mblDoc.uuid || !mblDoc.mark || ([1, 2].indexOf(seaCargoMark) > -1 && (!mblDoc._mergeHblDataTime || (mblDoc._markTime && mblDoc._markTime > mblDoc._mergeHblDataTime)) && job.mark !== oldJob.mark)) { mblDoc.mark = job.mark }
      if (!mblDoc.uuid || !mblDoc.cargoEnglishName || [1, 2].indexOf(seaCargoEnglishName) > -1 && (!mblDoc._mergeHblDataTime || (mblDoc._cargoEnglishNameTime && mblDoc._cargoEnglishNameTime > mblDoc._mergeHblDataTime)) && job.cargoEnglishName !== oldJob.cargoEnglishName) {
        mblDoc.cargoEnglishName = job.cargoEnglishName
      }
      // CARGO-9437 复制业务，能把提单页签的品名和唛头都复制下来
      if (job.signMBL && this.view.action === 'copy') {
        mblDoc.mark = oldMark
        mblDoc.cargoEnglishName = oldCargoEnglishName
      }
      if ((!mblDoc.uuid || !mblDoc.cargoManifestName) && job.jobState !== -1) { mblDoc.cargoManifestName = job.cargoEnglishName }
      if (!mblDoc.uuid || !mblDoc.quantitySum || billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
        const packing = this.packingList.find(p => p.code === this.job.packing)
        const packingName = job.jobState !== -1 ? (packing ? packing.name : this.job.packing) : ''
        mblDoc.quantitySum = StrUtils.jsdx(job.quantityActual, packingName)
      }
      if (isInsidePacking === 1) {
        mblDoc.insidePacking = job.insidePacking
      }
      if (!mblDoc.uuid) {
        await CargoDocUtil.initMBLProperties(mblDoc, job, this.view.action)
        if (job.mblOnly && job.jobState !== -1 && this.view.action !== 'copy') { // 订舱预审不同步收发通
          new SeaCargoDoc(mblDoc).copyBasicShipper(job)
          new SeaCargoDoc(mblDoc).copyBasicConsignee(job)
          new SeaCargoDoc(mblDoc).copyBasicNotify(job)
        }
        if (hblDoc) {
          await CargoDocUtil.initHBLProperties(hblDoc, job)
        }
        await CargoDocUtil.checkOverseaAgentProperties(job)
      }
      if (job.quantityActual !== oldJob.quantityActual || job.weightActual !== oldJob.weightActual ||
        job.cubageActual !== oldJob.cubageActual || job.chargeWeight !== oldJob.chargeWeight) {
        CargoDocUtil.changeJobSynToBillOfLading(job, mblDoc)
      }
      if (this.view.isEdit && job.insideQuantity >= 0) {
        mblDoc.insideQuantity = job.insideQuantity
      }
      if (!StrUtils.isEmpty(job.packing) && job.jobState !== -1) {
        mblDoc.packing = job.packing
      }
      if (!job.uuid) {
        let packingName = ''
        if (billOfLadingSynMode === 1 || billOfLadingSynMode === 2) {
          const packing = this.packingList.find(p => p.code === this.job.packing)
          packingName = packing ? packing.name : this.job.packing
        }
        if (job.quantityActual > 0) {
          mblDoc.quantitySum = StrUtils.jsdx(job.quantityActual, packingName)
        } else {
          mblDoc.quantitySum = StrUtils.jsdx(job.quantityContract, packingName)
        }
      }
    }
    // 仓库
    await this.getWarehouseInfo()
    // 车队
    await this.getTruckingInfo()
    const expression = parseInt(this.config.get('ContainerUpdateJobQCW'))
    if (expression === 3 && this.view.isTabContainerInfo && this.view.isEdit) {
      ContainerUtil.refContainerUsageQwc(job, 0, this.view.btnSave)
    }
    this.view.isTabContainerInfo = false
    this.view.btnSave = true
    // 同步报关行
    await JobUtils.synCustomsBroker(job, job.customsBroker)
  }
  loadForBookingResultHandler() {
    this.loadWarehouseCmp()
    this.loadTrucking2()
    this.loadWarehouseInDetails()
    this.checkCargoDocState()
  }
  loadPushHistoryLogsHandler(evt = null) {
    AutoContaninerFactory.getInstance().job = this.job
    const fields = [
      {
        fieldName: this.view.$t('SeaExport.ActualQuantity'),
        key: 'quantityActual'
      }, {
        fieldName: this.view.$t('CargoMsg.Cargo_ActualWeight'),
        key: 'weightActual'
      }, {
        fieldName: this.view.$t('SeaExport.ActualVolume'),
        key: 'cubageActual'
      }
    ]
    fields.forEach(item => {
      ensureExecuteSuccess(() => this.view.$refs[item.key]).then(() => {
        const el = this.view.$refs[item.key].$el
        const className = 'input-blue'
        if (DataPushCompareUtils.comparePushData(item.fieldName, String(this.view.form[item.key]), this.job[item.key])) {
          if (!el.classList.contains(className)) {
            el.classList.add(className)
          }
        } else {
          if (el.classList.contains(className)) {
            el.classList.remove(className)
          }
        }
      })
    })
  }
  //  MBL勾选
  async isMBLChange() {
    if (this.job.signMBL) {
      const job = new SeaExportJob(this.job)
      const mbl = await job.getCargoDocByDocType(CargoDocConsts.MBL, true)
      await CargoDocUtil.initMBLProperties(mbl, this.job, '')
      new SeaCargoDoc(mbl).copyBasicConsignee(job)
      new SeaCargoDoc(mbl).copyBasicNotify(job)
      CargoDocUtil.checkOverseaAgentProperties(job).then(r => {})
    }
  }
  // HBL勾选
  async isHBLChange() {
    if (this.job.signHBL) {
      const job = new SeaExportJob(this.job)
      const hbl = new SeaCargoDoc(await job.getCargoDocByDocType(CargoDocConsts.HBL, true))
      await CargoDocUtil.initHBLProperties(hbl, this.job)
      job.copySCNotifyToDoc(hbl)
      CargoDocUtil.checkOverseaAgentProperties(job).then(r => {})
    }
  }
  // 委托单位选择（从写委托单位选择，去掉当前与分公司校验）
  customerIdChangeNew(event) {
    const job = this.job
    job.editCftMode = false
    const company = this.companyList.find(p => p.cmpIdx === job.customerId)
    if (company) {
      // CARGO-1986 淳宏：合伙伙伴中同时勾选指定货和自拦货时，新增业务时揽货类型，无法选择
      this.loadCustomerDetail(event)// 联系人或者揽货类型
      this.showCustomerDetail()// 客户级别
      this.loadCustomerPortDestinationAgents()
      this.loadCompanyUser()// 销售
      this.loadCompanyUserByCargoSource()
      if (company.mustInputScn) {
        job.editCftMode = true
      }
    } else {
      job.customerId = 0
      if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
        this.view.txtSalesOffice = ''
        job.sales = 0 // 销售
        job.dc = 0 // 单证
        job.csr = 0 // 客服
      }
      this.getTxtSalesPrompt()
    }
  }
  // 整拼类型选择
  containerLoadTypeChange(containerLoadType) {
    const job = this.job
    if (containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
      this.job.bookingTerm = BookingTerm.NS_BOOKING_TYPE.code
    } else if (containerLoadType === 'FCL' || containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code) {
      this.job.vgm = true
    }
    this.warehouseNoeditableCl()
    this.seaEqDateCl().then(r => {})
    if (containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code || containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code ||
        containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code) {
      if (this.view.$refs.bookingSeaEqDataGrid) this.view.$refs.bookingSeaEqDataGrid.clear()
    }
    // 整拼类型不为散杂货，但是散杂货信息有值时清空
    if (containerLoadType !== ContainerLoadType.BULK_CARGO_TYPE.code && this.view.cargoBulkDetailList && this.view.cargoBulkDetailList.length > 0) {
      this.view.cargoBulkDetailList = []
    }
    // 整拼类型不为散杂货，但是散杂货信息有值时清空
    if (containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code && this.view.seaEqList && this.view.seaEqList.length > 0) {
      this.view.seaEqList = []
      this.job.containers = []
      this.job.containerUsages = []
    }
    if (!job.freightTermHBL) {
      this.changeDefaultHBLPayment()
    }
    this.selectDefaultLocalService()
    this.selectDefaultCutomJobType()
    this.selectFreightTermByBulkCargo()
    if (containerLoadType !== ContainerLoadType.BULK_CARGO_TYPE.code && this.view.cargoBulkDetailList.length > 0) {
      job.insideQuantitySize = 0
    }
    this.view.$emit('containerLoadTypeChange')
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    this.view.customJobTypeList = JobUtils.setCustomJobTypeList(this.job.lob, this.job.containerLoadType, this.job.fba)
  }
  /**
   * ETD 选择控制
   */
  ETDChange(oldValue) {
    if (this.view.readonly) return
    for (const cargoDoc of this.job.seaCargoDoc) {
      const allow = (cargoDoc.docType === CargoDocConsts.MBL || cargoDoc.docType === CargoDocConsts.MBL2 ||
        cargoDoc.docType === CargoDocConsts.HBL || cargoDoc.docType === CargoDocConsts.HBL2 ||
        cargoDoc.docType === CargoDocConsts.HAWB2) && cargoDoc.state < 2 && (!cargoDoc.signDateBL ||
        (oldValue && dateCompare(cargoDoc.signDateBL, oldValue) === 0))
      if (allow) {
        cargoDoc.signDateBL = this.job.etd
      }
    }
    if (this.job.etd) {
      // 截单日期默认天数
      const fileCutoffDay = parseInt(this.config.get('SEFileCutoffDetaultDay'))
      if (fileCutoffDay > 0 && this.job.etd) {
        const fileCutoff = DateUtils.getFourDaysAgoWithoutHoliday(this.job.etd, fileCutoffDay)
        fileCutoff.setHours(12, 0)
        this.job.fileCutoff = DateUtils.formatStandardDateTime(fileCutoff)
      }
    }
  }
  /**
   * 提单发货地修改
   */
  async cargoDocChangeHandler() {
    const job = this.job
    // let mblDoc = await new SeaExportJob(job).getMainMbl()
    const mblDoc = await new SeaExportJob(job).getCargoDocByDocType(CargoDocConsts.AMS, false)
    if (mblDoc && mblDoc.state > 0) {
      await SeaCargoDoc.copyInfoFromJobPort(job, mblDoc)
    }
  }
  /**
   * 提单发货地
   */
  async changeDispatchingPlace(event) {
    const job = this.job
    const hbl = await new SeaExportJob(job).getMainHbl()
    if (hbl) {
      if (hbl.state > 1) return
      hbl.dispatchingPlace = job.dispatchingPlace
    }
    const mbl = await new SeaExportJob(job).getMainMbl()
    if (mbl) {
      if (mbl.state > 1) return
      mbl.dispatchingPlace = job.dispatchingPlace
    }
  }
  /**
   * 提单起运港
   */
  async changeLoadingPort(event) {
    const job = this.job
    const hbl = await new SeaExportJob(job).getMainHbl()
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    const ports = seaPorts.filter(p => p.code === job.loadingPortCode)
    if (hbl) {
      if (hbl.state > 1) return
      if (job.loadingPortCode && job.loadingPortCode.length > 0) {
        if (ports && ports.length > 0) {
          hbl.loadingPort = ports[0].englishName
          hbl.loadingPortCode = job.loadingPortCode
        }
      }
    }
    const mbl = await new SeaExportJob(job).getMainMbl()
    if (mbl) {
      if (mbl.state > 1) return
      if (job.loadingPortCode && job.loadingPortCode.length > 0) {
        if (ports && ports.length > 0) {
          mbl.loadingPort = ports[0].englishName
          mbl.loadingPortCode = job.loadingPortCode
        }
      }
    }
  }
  /**
   * 提单最终目的地
   */
  async changeDestinationPlace(event) {
    const job = this.job
    const hbl = await new SeaExportJob(job).getMainHbl()
    if (hbl) {
      if (hbl.state > 1) return
      if (hbl.docType !== CargoDocConsts.MBL && hbl.docType !== CargoDocConsts.MBL2) {
        hbl.destinationPlace = job.destinationPlace
      }
    }
    const mbl = await new SeaExportJob(job).getMainMbl()
    if (mbl) {
      if (mbl.state > 1) return
      mbl.destinationPlace = job.destinationPlace
    }
  }
  /**
   * 提单卸货港
   */
  async changeDischargingPort() {
    const job = this.job
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    const hbl = await new SeaExportJob(job).getMainHbl()
    if (hbl) {
      if (hbl.state > 1) return
      if (job.dischargingPortCode) {
        const hblPort = seaPorts.find(p => p.code === job.dischargingPortCode)
        if (hblPort) {
          hbl.dischargingPort = hblPort.englishName
          hbl.dischargingPortCode = job.dischargingPortCode
          if (job.dischargingPortCode === job.destinationPortCode) {
            hbl.destinationPort = hblPort.englishName
            hbl.destinationPortCode = job.dischargingPortCode
          }
        }
      }
    }
    const mdoc = await new SeaExportJob(job).getMainMbl()
    if (mdoc) {
      if (mdoc.state > 1) return
      if (job.dischargingPortCode && job.dischargingPortCode.length > 0) {
        const mblPort = seaPorts.find(p => p.code === job.dischargingPortCode)
        if (mblPort) {
          mdoc.dischargingPort = mblPort.englishName
          mdoc.dischargingPortCode = job.dischargingPortCode
          if (job.dischargingPortCode === job.destinationPortCode) {
            mdoc.destinationPort = mblPort.englishName
            mdoc.destinationPortCode = job.dischargingPortCode
          }
        }
      }
    }
  }
  /**
   * 提单交货地
   */
  async changeDestinationPort(event) {
    const job = this.job
    if (job.destinationPortCode && job.destinationPortCode.length > 0) {
      const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
      const ports = seaPorts.filter(p => p.code === job.destinationPortCode)
      if (ports && ports.length > 0) {
        const hbl = await new SeaExportJob(job).getMainHbl()
        if (hbl) {
          if (hbl.state > 1) return
          hbl.destinationPort = ports[0].englishName
          hbl.destinationPortCode = job.destinationPortCode
        }
        const mbl = await new SeaExportJob(job).getMainMbl()
        if (mbl) {
          if (mbl.state > 1) return
          mbl.destinationPort = ports[0].englishName
          mbl.destinationPortCode = job.destinationPortCode
        }
      }
    }
  }
  /**
   * 卸货港选择
   */
  async dischargingPortCodeChange(value, carrierId, allowPopup = true) {
    const job = this.job
    this.isClearDestinationAgent = true
    this.loadOverseaAgentPort().then(r => {})
    if (this.sEUseDischargingPort5Code && value) {
      this.refreshPortCode(value, carrierId)
    }
    if (job.dischargingPortCode !== value) {
      this.dischargingPortIsDirty = true
      job.overseaAgentPort = null
      job.dischargingPortCode = value
      const oldDestinationPortCode = job.destinationPortCode
      if (Number(this.config.get('SyncPOD')) === 1) {
        job.destinationPortCode = job.dischargingPortCode
      } else {
        job.destinationPortCode = job.destinationPortCode || job.dischargingPortCode
      }
      let port = null
      if (job.destinationPortCode) {
        const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
        port = seaPorts.find(p => p.code === job.destinationPortCode)
      }
      job.placeOfDeliveryRegion = port ? port.region : ''
      if (port && oldDestinationPortCode !== job.destinationPortCode && parseInt(this.config.get('FinalDestinationChange')) === 1) {
        this.job.destinationPlace = port.englishName
      }
    } else {
      this.dischargingPortIsDirty = false
    }
    this.portChange().then(r => {})
    this.setPlannerChange()
    this.loadCustomerPortDestinationAgents(allowPopup).then(r => {})
    JobUtils.matchUserPortConfig(this.view, job)
    JobUtils.matchRegionWarehouseMappingConfig(job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    JobUtils.loadingShipDate(job)
  }
  /**
   * 交货地选择
   */
  destinationPortCodeChange(data) {
    if (this.job.destinationPortCode !== data.value) {
      this.job.destinationPortCode = data.value
      this.portChange().then(r => {})
      this.setPlannerChange()
    }
    // 开启配置项后交货地变更不会带到最终目的地1开启 0关闭(默认)
    if (parseInt(this.config.get('FinalDestinationChange')) === 1) {
      this.job.destinationPlace = data.englishName
    }
  }
  /**
   * 修改船公司
   */
  carrierChangeHandler(value, carrierId) {
    const job = this.job
    job.carrierId = carrierId
    this.carrierIdIsDirty = true
    if (!job.masterFlag && this.sEUseDischargingPort5Code) {
      this.refreshPortCode(value, carrierId)
    }
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    JobUtils.loadingShipDate(job)
  }
  /**
   * 船公司选择
   */
  carrierFocusOutEventHandler(carrierId) {
    if (this.carrierIdIsDirty) {
      this.refreshBookingAgentAutoComplete().then(r => {})
      this.carrierIdIsDirty = false
    }
  }
  /**
   * 船公司要与订舱代理进行关联
   */
  async refreshBookingAgentAutoComplete() {
    const job = this.job
    if (!this.isJoinCarrierBookingAgent || job.containerLoadType === 'BB') return
    const company = await Company.getCompanyById(job.carrierId)
    if (company) {
      this.view.bookingAgentDataProviderChange = true
      await company.getBookingAgentList(true, false)
      const dataArray = []
      for (const bookingAgentCarrier of company.bookingAgentList) {
        dataArray.push(bookingAgentCarrier.bookingAgent)
      }
      this.bookingAgentArray = dataArray
    }
    job.bookingAgent = 0
  }

  /**
   * 订舱代理选择
   */
  bookingAgentChangeHandler(event) {
    const job = this.job
    if (job.bookingAgent && parseInt(job.bookingAgent) > 0) {
      job.preBookingAgent = job.bookingAgent
    }
    if (!event.value) {
      job.bookingAgent = 0
      return
    }
    // 这个验证必须在 job.bookingAgent = event.value 赋值之前，否则此验证无意义
    SEUtils.refreshChargeAccountId(job, 'bookingAgent', this.view.$t('SeaExport.BookingAgent'), this.view.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
    job.bookingAgent = event.value
    if (!job.bookingAgent) return
    this.carrierAgentSyncLoading().then(r => {})
    this.bookingAgentChangeCl()
  }
  /**
   * 是否同步船代
   */
  async carrierAgentSyncLoading() {
    if (this.job.bookingAgent > 0) {
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (company && company.seaCmpAgent) {
        this.job.carrierAgentId = this.job.bookingAgent
      }
    }
  }
  /**
   * 揽货类型选择
   */
  async cargoSourceChange(event) {
    const job = this.job
    this.loadDestinationAgentDetaiHandler().then(r => {})
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      job.sales = 0
      job.salesOffice = 0
      job.salesDepartment = 0
      this.view.txtSalesOffice = ''
      this.view.salesList = null
      job.paymentTermHBL = 'CC'
      this.loadOverseaAgentDetailOwner(job.designationAgent).then(r => {})
      // HBL放单，当揽货类型为指定时，默认勾选公司自出单
      const hblDoc = await new SeaExportJob(job).getMainHbl()
      if (hblDoc) {
        hblDoc.customerSelfRelease = 2
      }
      this.job.incoTerm = ColumnUtils.getIncoTermIsFobOrCif('FOB')
    } else {
      job.paymentTermHBL = 'PP'
      job.designationAgent = 0
      this.customerIdChangeNew(event)
      this.job.incoTerm = ColumnUtils.getIncoTermIsFobOrCif('CIF')
    }
    const hblPaymentTerm = this.context.paymentTermList.find(p => p.code === job.paymentTermHBL)
    if (hblPaymentTerm) {
      this.paymentSelectHblChange(hblPaymentTerm.code, hblPaymentTerm.name)
    }
    if (this.lclslaveEnabled) {
      job.paymentTermMBL = job.paymentTermHBL
      this.paymentTermMBL_Change(job.paymentTermMBL)
    }
    this.loadCustomerPortDestinationAgents()
    CargoDocUtil.changeHBLAgentParty(job)
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) { // 如果是指定货
      this.loadOverseaAgentUserByLob(job.designationAgent) // 根据指定货确定海外客服
    } else {
      this.loadOverseaAgentUserByLob(job.destinationAgent)// 还是根据目的港代理确定海外客服
    }
    this.checkNewJobCreditInfo()
    this.loadCompanyUserByCargoSource()
  }
  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfo() {
    const job = this.job
    if (this.view.creditOpen && StrUtils.isEmpty(job.uuid)) {
      // 新增业务时，需要判断是否可以新增该业务 CARGO-9472 超信控的合作伙伴不能新增业务
      const checkResult = this.checkNewJobCreditInfoFunc(job)
      this.view.processingPromiseList.push(checkResult)
      try {
        await checkResult
      } finally {
        const index = this.view.processingPromiseList.indexOf(checkResult)
        if (index > -1) {
          this.view.processingPromiseList.splice(index, 1)
        }
      }
    }
  }
  /**
   * 校验新增业务的信控
   * @param job
   * @returns {Promise<void>}
   */
  async checkNewJobCreditInfoFunc(job) {
    const params = JobUtils.getCreditCheckJob(job)
    await canCreateByCreditInfoDetail(params).then(async res => {
      if (res.data > 0) {
        const msg = {
          dangerouslyUseHTMLString: true,
          message: await JobUtils.checkDateAndAmountExceeded(res.data),
          type: 'warning',
          duration: 5000
        }
        this.view.$message.warning(msg)
        if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
          this.view.showWarningImageA = false
          job.designationAgent = 0
        } else {
          this.view.showWarningImageB = false
          job.customerId = 0
        }
      }
    })
  }
  // 按业务指定海外客服
  async loadOverseaAgentUserByLob(cmpIdx) {
    if (this.view.isHC) {
      return
    }
    const job = this.job
    const cmp = this.companyList.find(p => p.cmpIdx === cmpIdx)
    if (cmp) {
      const overseaAgentDetail = await new Company(cmp).getOverseaAgentDetail()
      this.loadDestinationAgentDetaiHandler(overseaAgentDetail)
    } else {
      const firstOption = this.view.$refs.overseaOp.options[0]
      job.overseaOp = firstOption ? firstOption.userId : 0
      job.overseaOpDepartment = 0
    }
  }
  async loadDestinationAgentDetaiHandler(agent) {
    if (this.view.isHC) {
      return
    }
    if (!agent) {
      const job = this.job
      const cmpIdx = job.cargoSource === CargoSource.NC_CARGO_SOURCE.code ? job.designationAgent : job.destinationAgent
      const company = this.companyList.find(p => p.cmpIdx === cmpIdx)
      if (company) {
        agent = await new Company(company).getOverseaAgentDetail()
      }
    }
    if (agent) {
      const overseaAgentUserList = await new OverseaAgent(agent).getOverseaAgentUserList()
      this.loadOverseaAgentUserHandler(overseaAgentUserList)
    }
  }
  loadOverseaAgentUserHandler(overseaAgentUsers) {
    // 海外客服
    const overseaAgentUsersList = []
    let overseaAgentUserDefaultId = 0
    if (overseaAgentUsers && overseaAgentUsers.length > 0) {
      for (const u of overseaAgentUsers) {
        if (u.lob === this.job.lob || !u.lob || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaAgentUserDefaultId = u.userId
              }
              overseaAgentUsersList.push(user)
            }
          }
        }
      }
    }
    // 海外客服
    this.view.overseaAgentUsersList = overseaAgentUsersList
    // 海外客服默认值
    if (overseaAgentUsersList.length > 0) {
      let overseaOp = 0
      if (overseaAgentUserDefaultId > 0) {
        overseaOp = overseaAgentUserDefaultId
      } else {
        overseaOp = overseaAgentUsersList[0].userId
      }

      let newUser = null
      if (overseaOp > 0) {
        newUser = this.userList.find(p => p.userId === overseaOp)
      }

      if (newUser && overseaOp !== this.job.overseaOp) {
        // 复制时判断
        if (this.view.action === 'copy') {
          const overseaUser = this.userList.find(p => p.userId === this.job.overseaOp)
          const oldOverseaUser = !overseaUser ? '' : !overseaUser.chineseName ? overseaUser.englishName : overseaUser.chineseName// 原业务 海外客服
          const newOverseaUser = !newUser ? '' : !newUser.chineseName ? newUser.englishName : newUser.chineseName// 新 海外客服
          if (overseaUser && this.isActiveOverSeaOp() && overseaAgentUsersList.find(p => p.userId === overseaUser.userId)) {
            overseaOp = this.job.overseaOp
          } else {
            let msg = this.view.$t('SeaExport.OverseaCustomerUpdate')
            msg = msg.replace('{0}', oldOverseaUser)
            msg = msg.replace('{1}', newOverseaUser)
            this.view.$confirm(msg, this.view.$t('Message.Prompt'), {
              confirmButtonText: this.view.$t('common.btn.ok'),
              cancelButtonText: this.view.$t('common.btn.cancel'),
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.job.overseaOp = overseaOp
            }).catch(() => {
              this.job.overseaOp = 0
            }).finally(() => {
              this.overseaOpChangeHandler()
            })
          }
        } else {
          this.job.overseaOp = overseaOp
          this.overseaOpChangeHandler()
        }
      }
    } else {
      this.job.overseaOp = 0
      this.job.overseaOpDepartment = 0
    }
  }
  /**
   * 目的港代理选择
   */
  txtDestinationAgentChangeHandler(data) {
    const job = this.job
    this.view.sopImageC = false
    this.view.showWarningImageC = false
    if (!data) {
      job.destinationAgent = 0
      return
    }
    if (!this.view.isHC) {
      this.view.overseaAgentUsersList = []
      this.job.overseaOp = 0
    }
    if (!data.value) {
      job.destinationAgent = 0
      return
    }
    if (this.view.creditOpen && data.value > 0) {
      this.checkCreditByCompany(data.value, 3)
    } else {
      if (data && this.view.sopConfigOpen) {
        this.view.sopImageC = data.ifOpenSop
      }
    }
    job.destinationAgent = data.value
    if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
      this.loadOverseaAgentUserByLob(job.destinationAgent).then(r => {})
    }
    // 自动目的港代理
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code && (this.refSelDesignationAgent || job.designationAgent === 0) && data.designationAgent) {
      job.designationAgent = data.cmpIdx
      this.loadOverseaAgentUserByLob(job.designationAgent)
      this.loadOverseaAgentDetail()
    }
    CargoDocUtil.checkOverseaAgentProperties(job)
  }
  /**
   * 指定货代理选择
   */
  designationAgentChangeHandler(data) {
    const job = this.job
    job.designationAgent = data.value || 0
    this.view.sopImageA = false
    this.view.showWarningImageA = false
    if (this.view.creditOpen && data.value > 0) {
      this.checkCreditByCompany(data.value, 2)
      this.checkNewJobCreditInfo()
    } else {
      const company = this.companyList.find(p => p.cmpIdx === job.designationAgent)
      if (this.view.sopConfigOpen && company) {
        // 判断该合作伙伴是否开启SOP
        this.view.sopImageA = company.ifOpenSop
      }
    }
    if (job.designationAgent > 0) {
      CargoDocUtil.changeHBLAgentParty(job).then(r => {})
      this.loadOverseaAgentDetail()
      if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
        this.loadOverseaAgentUserByLob(job.designationAgent)// 根据指定货确定海外客服
      }
    } else {
      if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
        if (!this.view.isHC) {
          job.overseaOp = 0
          job.overseaOpDepartment = 0
          this.view.overseaAgentUsersList = []
        }
      }
    }
  }
  /**
   * 本地服务选择
   */
  loadingTermChange(fieldName) {
    const job = this.job
    if (fieldName === 'warehousing') {
      if (!job.warehousing) {
        job.warehouseCmp = 0
        if (job.warehouseInfo && job.warehouseInfo.length > 0) {
          for (const item of job.warehouseInfo) {
            if (item.uuid) {
              item.jobUuid = ''
              this.addWarehouseToModifiedSet(item)
            } else {
              this.removeWarehouseFromModifiedSet(item)
            }
          }
        }
      }
    } else if (fieldName === 'landTransportation') {
      if (!job.landTransportation) {
        job.carryingCmp = 0
        // 取消勾选客户门点/提货，清空客户门点页签信息
        if (job.trucking && job.trucking.length > 0) {
          for (const item of job.trucking) {
            if (item.uuid) {
              item.jobUuid = ''
              this.addTruckingToModifiedSet(item)
            } else {
              this.removeTruckingFromModifiedSet(item)
            }
          }
        }
      }
    }
    this.warehouseNoeditableCl()
  }
  /**
   * 自动配货(外部接口)
   */
  async autoAllocateExternalHandler() {
    if (!this.job.uuid) {
      throw new ErrorTip('亲，请先保存业务，再进行自动配货操作。')
    }
    this.context.loading = true
    try {
      await WarehouseIn.externalAutoAllocate(this.job.uuid, this.job.warehouseNo)
      await this.externalAllocateResultHandler()
    } finally {
      this.context.loading = false
    }
  }
  /**
   * 配货结果返回
   */
  async externalAllocateResultHandler() {
    this.job.warehouseIn = ''
    const data = await new SeaExportJob(this.job).getWarehouseIn()
    this.reloadWarehouseInResultHandler(data)
  }
  reloadWarehouseInResultHandler(warehouseIn) {
    if (warehouseIn && warehouseIn.length > 0) {
      this.view.$message.success(this.view.$t('Message.DistributedSuccessfully'))
    } else {
      this.view.$message.error(this.view.$t('SeaExport.DistributionFailed'))
    }
  }
  /**
   * 刷新进仓编号
   */
  async clickWarehouseNoHandler() {
    const hbl = []
    const list = await new SeaExportJob(this.job).getSeaCargoDoc()
    if (list) {
      for (const doc of list) {
        if (doc.docType === CargoDocConsts.HBL2) {
          if (!hbl.includes(doc.warehouseNo)) {
            hbl.push(doc.warehouseNo)
          }
        }
      }
    }
    hbl.sort()
    this.job.warehouseNo = hbl.join(',')
  }
  /**
   * 检查业务参考号是否存在
   */
  async customerRefNoFocusOutHandler(event) {
    const job = this.job
    if (!StrUtils.isEmpty(job.customerRefNo)) {
      const checkJobFields = {}
      checkJobFields.customerRefNo = job.customerRefNo
      const fieldExistResult = await SeaExportJob.checkJobFieldExist(this.view.$store.getters.currentOfficeId, job.lob, checkJobFields, job.uuid)
      if (fieldExistResult.customerRefNo) {
        this.view.customerRefNoTip = this.view.$t('Message.BusinessReferenceNoReduplicated')
      } else {
        this.view.customerRefNoTip = ''
      }
    }
  }
  // 运输公司
  carryingCmpChangeHandler(data) {
    const job = this.job
    job.carryingCmp = data.value
    if (job.trucking.length === 0) {
      const newData = new TruckingInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.trucking.push(newData)
    }
    const truckingInfo = job.trucking[0]
    truckingInfo.carryingCmp = job.carryingCmp
    if (!job.carryingCmp || job.carryingCmp === 0) {
      truckingInfo.driver = ''
      truckingInfo.driverTel = ''
    }
    this.addTruckingToModifiedSet(truckingInfo)
  }
  // 添加truckingInfo到被修改的集合中
  addTruckingToModifiedSet(truckingInfo) {
    const modifiedData = this.context.modifiedData
    modifiedData.truckingInfo = modifiedData.truckingInfo || []
    if (!modifiedData.truckingInfo.includes(truckingInfo)) {
      modifiedData.truckingInfo.push(truckingInfo)
    }
  }
  // 将truckingInfo从被修改的集合中移除
  removeTruckingFromModifiedSet(truckingInfo) {
    const modifiedData = this.context.modifiedData
    if (modifiedData.truckingInfo && modifiedData.truckingInfo.includes(truckingInfo)) {
      const index = modifiedData.truckingInfo.indexOf(truckingInfo)
      if (index > -1) {
        modifiedData.truckingInfo.splice(index, 1)
      }
    }
  }
  /**
   * 仓库
   */
  async warehouseCmpChangeHandler(data) {
    const job = this.job
    job.warehouseCmp = data.value || 0
    job.warehouseRecord = job.warehouseCmp
    if (job.warehouseInfo.length === 0) {
      const newData = new WarehouseInfo().fillDefaultValue().getData()
      newData.jobUuid = job.uuid
      job.warehouseInfo.push(newData)
    }
    // 通过此方法加载 warehouseInfo 的联系电话地址等
    await this.getWarehouseInfo()
    const warehouse = job.warehouseInfo[0]
    warehouse.warehouseCmp = job.warehouseCmp
    if (warehouse.warehouseCmp && warehouse.warehouseCmp > 0) warehouse.deleted = false
    this.addWarehouseToModifiedSet(warehouse)
  }
  // 添加warehouseInfo到被修改的集合中
  addWarehouseToModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    modifiedData.warehouseInfo = modifiedData.warehouseInfo || []
    if (!modifiedData.warehouseInfo.includes(warehouse)) {
      modifiedData.warehouseInfo.push(warehouse)
    }
  }
  // 将warehouseInfo从被修改的集合中移除
  removeWarehouseFromModifiedSet(warehouse) {
    const modifiedData = this.context.modifiedData
    if (modifiedData.warehouseInfo && modifiedData.warehouseInfo.includes(warehouse)) {
      const index = modifiedData.warehouseInfo.indexOf(warehouse)
      if (index > -1) {
        modifiedData.warehouseInfo.splice(index, 1)
      }
    }
  }
  // 分单运输条款
  async freightTermHBLChange() {
    const job = this.job
    const cargoDocs = await new SeaExportJob(job).getCargoDoc()
    const hbl2CargoDocs = []
    if (cargoDocs && cargoDocs.length > 0) {
      for (const cargoDoc of cargoDocs) {
        if (cargoDoc.docType === CargoDocConsts.HBL) {
          cargoDoc.freightTermHBL = job.freightTermHBL
        } else if (cargoDoc.docType === CargoDocConsts.HBL2) {
          hbl2CargoDocs.push(cargoDoc)
        }
      }
      if (hbl2CargoDocs.length > 0) {
        const hbl2CargoDoc = hbl2CargoDocs[0]
        hbl2CargoDoc.freightTermHBL = job.freightTermHBL
      }
    }
  }

  // 修改货物信息
  async cargoCodeChange(data) {
    const job = this.job
    job.cargoCode = data
    if (data === null || data === '') {
      job.cargoCode = data
      job.cargoName = ''
    } else {
      const cargoInformation = getObjectByCache(basicCacheKeys.basic_data_CargoInformation, 'code', data)
      if (cargoInformation) {
        job.cargoCode = cargoInformation.code
        job.cargoName = cargoInformation.englishName
      }
    }
  }
  // 主单运输条款
  paymentTermMBLChange() {
    this.paymentPlaceBLShowChange().then(r => {})
    this.portChange().then(r => {})
    this.setPlannerChange()
  }
  // 主单运费方式
  paymentTermMBL_Change(value) {
    this.job.paymentTermMBL = value
    this.paymentPlaceBLShowChange().then(r => {})
    this.portChange().then(r => {})
  }
  async paymentPlaceBLShowChange() {
    if (!this.job.paymentTermMBL) return
    this.isShowAcPaymentPlaceBL = false
    const paymentTermMblName = this.context.paymentTermList.find(p => p.code === this.job.paymentTermMBL)
    const isContainerElseWhere = paymentTermMblName && !StrUtils.isEmpty(paymentTermMblName.name) && paymentTermMblName.name.toUpperCase().indexOf('ELSEWHERE') >= 0
    if (isContainerElseWhere) {
      this.isShowAcPaymentPlaceBL = true
      const mbl = await new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.MBL, true)
      this.view.mblDoc.paymentPlaceBL = mbl.paymentPlaceBL
    }
  }
  /**
   * 分单运输条款
   */
  paymentSelectHblChange(paymentCode) {
    this.job.paymentTermHBL = paymentCode || ''
    this.portChange().then(r => {})
    this.setPlannerChange()
  }
  // 订舱性质
  bookingTermChange(value) {
    this.warehouseNoeditableCl()
  }
  // 发货人选择
  async shipperChange(data) {
    const form = this.job
    form.shipperId = data.value
    const sycSCN = await parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    if (form.shipperId) {
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.shipperLine1 = manifestAddress.addressLine1
        form.shipperLine2 = manifestAddress.addressLine2
        form.shipperLine3 = manifestAddress.addressLine3
        form.shipperLine4 = manifestAddress.addressLine4
        form.shipperLine5 = manifestAddress.addressLine5
        form.shipperLine6 = manifestAddress.addressLine6
        form.shipperLine7 = manifestAddress.addressLine7
      } else {
        form.shipperLine1 = ''
        form.shipperLine2 = ''
        form.shipperLine3 = ''
        form.shipperLine4 = ''
        form.shipperLine5 = ''
        form.shipperLine6 = ''
        form.shipperLine7 = ''
      }
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'shipper', 0, manifestAddress)
    } else {
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'shipper', 0, null)
    }
  }
  /**
   * 收货人选择
   */
  async consigneeChange(data) {
    const form = this.job
    form.consigneeId = data.value
    const sycSCN = await parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
    if (form.consigneeId) {
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.consigneeLine1 = manifestAddress.addressLine1
        form.consigneeLine2 = manifestAddress.addressLine2
        form.consigneeLine3 = manifestAddress.addressLine3
        form.consigneeLine4 = manifestAddress.addressLine4
        form.consigneeLine5 = manifestAddress.addressLine5
        form.consigneeLine6 = manifestAddress.addressLine6
        form.consigneeLine7 = manifestAddress.addressLine7
      } else {
        form.consigneeLine1 = ''
        form.consigneeLine2 = ''
        form.consigneeLine3 = ''
        form.consigneeLine4 = ''
        form.consigneeLine5 = ''
        form.consigneeLine6 = ''
        form.consigneeLine7 = ''
      }
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'consignee', 0, manifestAddress)
    } else {
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'consignee', 0, null)
    }
  }
  /**
   * 通知人选择
   */
  async notifyChange(data) {
    const form = this.job
    form.notifyId = data.value
    const sycSCN = await parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
    if (form.notifyId) {
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.notifyLine1 = manifestAddress.addressLine1
        form.notifyLine2 = manifestAddress.addressLine2
        form.notifyLine3 = manifestAddress.addressLine3
        form.notifyLine4 = manifestAddress.addressLine4
        form.notifyLine5 = manifestAddress.addressLine5
        form.notifyLine6 = manifestAddress.addressLine6
        form.notifyLine7 = manifestAddress.addressLine7
      } else {
        form.notifyLine1 = ''
        form.notifyLine2 = ''
        form.notifyLine3 = ''
        form.notifyLine4 = ''
        form.notifyLine5 = ''
        form.notifyLine6 = ''
        form.notifyLine7 = ''
      }
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'notify', 0, manifestAddress)
    } else {
      await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'notify', 0, null)
    }
  }
  // 是否直单
  isMblOnlyChange() {
    this.job.signHBL = this.job.mblOnly ? false : this.job.signHBL
  }
  // 包装选择
  async txtPackingChangeHandler(event = null) {
    const mbl = await new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.MBL, false)
    if (mbl) {
      if (this.job.quantityContract > 0) {
        const packing = this.packingList.find(p => p.code === this.job.packing)
        mbl.quantitySum = StrUtils.jsdx(parseInt(this.job.quantityContract), packing ? packing.name : this.job.packing)
      }
    }
  }
  getTxtSalesPrompt() {
    if ((Number(this.config.get('IsSpecifiedSalesBusiness')) === 1) && (this.view.$refs.sales.options.length === 0)) {
      this.view.salesPrompt = this.view.$t('SeaExport.PleaseMaintainTheCorrespondingSalesInThePartner')
    } else {
      this.view.salesPrompt = ''
    }
  }
  // 当选择销售人员的时候自动关联该销售所在分公司
  async salesChangeHandler(data) {
    const job = this.job
    job.sales = data.value
    job.salesOffice = 0
    this.view.txtSalesOffice = ''
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(job.salesOffice)
        this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices.length > 1) {
          for (const item of offices) {
            if (this.view.branchOfficeCheck || (!this.view.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              this.loadCompanyOffice()
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          job.salesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          if (office) {
            job.salesOffice = office.officeId
            this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
          }
        }
      }
    }
    this.dipatchChangedSalesEvent(data.userId || 0)
  }
  /**
   * 销售部门修改后，调整分公司信息
   */
  departmentChargeHandler(event = null) {
  }
  async loadCompanyOffice() {
    const job = this.job
    const office = await Office.getOfficeById(job.salesOffice)
    if (office) {
      this.view.txtSalesOffice = this.view.isZh ? office.chineseName : office.englishName
    } else {
      this.view.txtSalesOffice = ''
    }
  }
  /**
   * 操作分公司选择
   */
  opOfficeChangeHandler(event) {
    JobUtils.opOfficeChange({ view: this.view, job: this.job, warehouseCallback: warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), modifiedData: this.context.modifiedData })
  }
  /**
   * 操作改变
   */
  txtOPChangeHandler(user) {
    const job = this.job
    if (user.defaultDepId > 0) {
      job.opDepartment = user.defaultDepId
    } else {
      if (job.opOffice > 0) {
        new User(user).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      } else {
        new User(user).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
          job.opDepartment = dep ? dep.departmentId : 0
        })
      }
    }
  }
  /**
   * 客服改变
   */
  async csrChangeHandler(data) {
    const job = this.job
    job.csr = data.value
    job.csrDepartment = 0
    job.csrOffice = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'csr')
      if (dep) {
        job.csrDepartment = dep.departmentId
        const office = await Office.getOfficeByUuid(dep.officeUuid)
        job.csrOffice = office ? office.officeId : 0
      }
    }
  }
  /**
   * 海外客服改变
   */
  async overseaOpChangeHandler(data) {
    if (data) {
      const dep = await new User(data).getDefaultDepartment('role', 'overseaOp')
      if (dep) {
        this.job.overseaOpDepartment = dep.departmentId
      }
    } else {
      this.job.overseaOpDepartment = 0
    }
  }
  getDefaultOverseaOpResult(event) {
  }
  async dcChangeHandler(data) {
    const job = this.job
    job.dc = data.value
    job.dcDepartment = 0
    job.dcOffice = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'doc')
      job.dcDepartment = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.dcOffice = office ? office.officeId : 0
    } else {
      job.dc = 0
      job.dcDepartment = 0
      job.dcOffice = 0
    }
  }
  /**
   * 航线改变
   */
  async txtPlannerChangeHandler(data) {
    const job = this.job
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'seaLine')
      job.plannerDepartment = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.plannerOffice = office ? office.officeId : 0
    } else {
      job.planner = 0
      job.plannerDepartment = 0
      job.plannerOffice = 0
    }
  }

  async prePortPlannerChangeHandler(data) {
    await JobUtils.prePortPlannerChangeHandler(data, this.job, this)
  }
  async lastMilePlannerChangeHandler(data) {
    await JobUtils.lastMilePlannerChangeHandler(data, this.job, this)
  }

  getPlannerResult(event) {
    // var dep: Department = event.result as Department
    // job.plannerDepartment = dep == null ? 0 : dep.departmentId
  }
  /**
   * 修改操作要求
   */
  operationContentDoubleClickHandler(event) {
    // SelectOperationReqUtil.popUpWindow(job, isEditing, view)
  }
  validate6Line(s) {
    return true
  }
  /**
   * 手动选择销售
   */
  dipatchChangedSalesEvent(sales) {
    // var salesEvent: CommonFormEvent = new CommonFormEvent('salesChanged')
    // salesEvent.data = sales
    // view.dispatchEvent(salesEvent)
  }
  viewOtherChanged() {
  }
  /**
   * 加载客户信息
   */
  async loadCustomerDetail(event) {
    const job = this.job
    const company = this.companyList.find(p => p.cmpIdx === job.customerId)
    if (company) {
      this.view.contactList = await new Company(company).getContacts()
      this.onCustomerContactLoad()
      this.onCustomerDetailLoad(event)
    }
  }
  onCustomerContactLoad() {
    let linkMan = ''
    if (this.view.contactList && this.view.contactList.length > 0) {
      var contact = this.getDefaultContact(this.view.contactList)
      if (contact) {
        linkMan = contact.contactPerson
      }
    }
    if (this.view.isEdit) {
      this.view.form.customerContact = linkMan
    }
  }
  /**
   * 获取默认联系人
   */
  getDefaultContact(ary) {
    let rs = null
    if (ary && ary.length > 0) {
      rs = ary[0]
      for (const contact of ary) {
        if (contact.defaultContact) {
          rs = contact
          break
        }
      }
    }
    return rs
  }
  async onCustomerDetailLoad(event) {
    const job = this.job
    const customer = this.companyList.find(p => p.cmpIdx === job.customerId)
    const customerDetail = await new Company(customer).getCustomerDetail()
    const oldCargoSource = job.cargoSource
    let newCargoSource = ''
    if (customer && customerDetail) {
      if (event && event.fieldName === 'cargoSource') {
        if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        } else if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
          this.loadCustomerDetailSales(job.customerId) // 自揽货取客户
        }
      } else if (customerDetail.designated && customerDetail.seftCanvass) {
        if (Number(this.config.get('CustomerDefaultCargoSource')) === 0) {
          newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          this.loadCustomerDetailSales(job.customerId) // 自揽货取客户
        } else {
          newCargoSource = CargoSource.NC_CARGO_SOURCE.code
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        }
      } else {
        if (customerDetail.designated) {
          newCargoSource = CargoSource.NC_CARGO_SOURCE.code
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        } else if (customerDetail.seftCanvass) {
          newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          this.loadCustomerDetailSales(job.customerId) // 自揽货取客户
        }
      }

      // CARGO-15204 输入委托单位后，揽货类型会从指定货变更为自揽货的错误
      if (oldCargoSource !== newCargoSource && newCargoSource) {
        const msg = newCargoSource === CargoSource.SC_CARGO_SOURCE.code ? this.view.$t('CargoMsg.Cargo_CustomerSpace3') : this.view.$t('CargoMsg.Cargo_CustomerSpace2')
        this.view.$confirm(this.view.$t('CargoMsg.Cargo_CargoSourceTip', [msg]), this.view.$t('common.tips.prompt'), {
          confirmButtonText: this.view.$t('common.btn.yes'),
          cancelButtonText: this.view.$t('common.btn.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          job.cargoSource = newCargoSource
          this.checkNewJobCreditInfo()
          this.loadCompanyUserByCargoSource()
        }).catch(() => {
        })
      }
    }
  }
  /**
   * 自揽货 -> 加载销售(如果合作伙伴服务人员有多个则不刷新)
   */
  async loadCustomerDetailSales(companyId) {
    if (!this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === companyId)
      await new Company(company).getCustomerDetail()
      if (company && company.customerDetail) {
        const salseTemp = company.customerDetail.sales
        const user = this.userList.find(p => p.userId === salseTemp)
        if (user && user.active) {
          this.salesChangeHandler({ ...user, value: salseTemp })
        }
      } else {
        this.salesChangeHandler({ value: 0 })
      }
    }
  }
  /**
   * 加载销售信息
   */
  loadSalesDptOffceChanged() {
    // if (job.sales > 0) {
    //   view.txtSales.selectedId = job.sales
    //   //				view.callLater(salesChangeHandler)
    // }
  }
  /**
   * 提单是否被锁定
   */
  async checkCargoDocState() {
    const job = this.job
    this.billChargeFlag = false
    await new SeaExportJob(this.job).getCargoDoc()
    if (job.cargoDoc && job.cargoDoc.length > 0) {
      for (const cargoDoc of job.cargoDoc) {
        if (cargoDoc.state === 2 && (cargoDoc.docType === CargoDocConsts.HBL || cargoDoc.docType === CargoDocConsts.HBL2)) {
          this.billChargeFlag = true
          break
        }
      }
    }
    await this.lockBookingTab()
    this.mblDoc = await new SeaExportJob(this.job).getCargoDocByDocType(CargoDocConsts.MBL, true)
  }
  /**
   * 按业务指定销售
   */
  loadCompanyUser() {
    if (this.isSpecifiedSalesBusiness) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadCompanyUserHandler(data)
        })
      }
    }
  }
  async loadCompanyUserHandler(companyUsers) {
    const job = this.job
    // 销售
    const salesList = []
    let salesDefaultId = 0
    // 客服
    const csrList = []
    let csrDefaultId = 0
    // 单证
    const dcList = []
    let dcDefaultId = 0
    // 揽货销售
    const cargoSalesList = []
    let cargoSalesId = 0
    // 操作
    const opList = []
    let opDefaultId = 0
    // 海外客服
    const overseaOpList = []
    let overseaOpDefaultId = 0
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList = []
    if (this.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId)
    }
    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
              if (this.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    if (u.defaultUser) {
                      salesDefaultId = u.userId
                    }
                    salesList.push(user)
                  }
                }
              } else {
                if (u.defaultUser) {
                  salesDefaultId = u.userId
                }
                salesList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
              if (u.defaultUser) {
                csrDefaultId = u.userId
              }
              csrList.push(user)
            } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
              if (u.defaultUser) {
                dcDefaultId = u.userId
              }
              dcList.push(user)
            } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
              if (u.defaultUser) {
                cargoSalesId = u.userId
              }
              cargoSalesList.push(user)
            } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
              if (u.defaultUser) {
                opDefaultId = u.userId
              }
              opList.push(user)
            } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaOpDefaultId = u.userId
              }
              overseaOpList.push(user)
            }
          }
        }
      }
    }
    if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
      // 销售
      this.view.salesList = salesList
      this.getTxtSalesPrompt()
      if (salesList.length > 0) {
        if (salesDefaultId > 0) {
          job.sales = salesDefaultId
        } else {
          job.sales = salesList[0].userId
        }
        this.view.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.sales)
          this.salesChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.sales = 0
        // job.salesDepartment = 0
        // this.view.txtSalesOffice = ''
      }
    }
    // 客服
    if (csrList.length > 0) {
      if (csrDefaultId > 0) {
        job.csr = csrDefaultId
      } else {
        job.csr = csrList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.csr)
        this.csrChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.csr = 0
      // job.csrDepartment = 0
    }
    // 单证
    if (dcList.length > 0) {
      if (dcDefaultId > 0) {
        job.dc = dcDefaultId
      } else {
        job.dc = dcList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.dc)
        this.dcChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.dc = 0
      // job.dcDepartment = 0
    }
    // 揽货销售
    if (cargoSalesList.length > 0) {
      if (cargoSalesId > 0) {
        job.cargoSalesId = cargoSalesId
      } else {
        job.cargoSalesId = cargoSalesList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.cargoSalesId)
        this.cargoSalesChargeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.cargoSalesId = 0
      // job.cargoSalesOffice = 0
      // job.cargoSalesDepartment = 0
    }
    if (this.view.isHC) {
      // 操作
      if (opList.length > 0) {
        if (opDefaultId > 0) {
          job.op = opDefaultId
        } else {
          job.op = opList[0].userId
        }

        const user = await User.getUserById(job.op)
        this.view.$nextTick(() => {
          this.txtOPChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.op = 0
        // job.opDepartment = 0
      }
      // 海外客服
      if (overseaOpList.length > 0) {
        if (overseaOpDefaultId > 0) {
          job.overseaOp = overseaOpDefaultId
        } else {
          job.overseaOp = overseaOpList[0].userId
        }

        const user = await User.getUserById(job.overseaOp)
        this.view.$nextTick(() => {
          this.overseaOpChangeHandler({ ...user, value: user.userId })
        })
      } else {
        // job.overseaOp = 0
        // job.overseaOpDepartment = 0
      }
    }
  }
  /**
   * 加载job仓库信息
   */
  loadWarehouseCmp() {
    const job = this.job
    if (job.warehouseInfo != null && job.warehouseInfo.length > 0) {
      job.warehouseCmp = job.warehouseInfo[0].warehouseCmp
    } else if (!shouldPreserveCopiedWarehouseCmp(job, this.view.action)) {
      job.warehouseCmp = 0
    }
  }
  /**
   * 加载job运输公司
   */
  loadTrucking2() {
    const job = this.job
    if (job.trucking && job.trucking.length > 0) {
      // 需要排序，因为业务调整更新的 TruckingId desc排序后的第一条，要及时反馈出来
      sortByMultiField(job.trucking, ['truckingId'], true)
      job.carryingCmp = job.trucking[0].carryingCmp
    } else if (!shouldPreserveCopiedCarryingCmp(job, this.view.action)) {
      job.carryingCmp = 0
    }
  }
  /**
   *  加载货物明细
   */
  loadWarehouseInDetails() {
    const job = this.job
    if (job.warehouseIn && job.warehouseIn.length > 0) {
      this.view.txtWhs = JobUtils.getWarehouseInDetail(job.warehouseIn)
    } else {
      this.view.txtWhs = ''
    }
  }
  /**
   * 刷新港口所对应的目的港和指定货代理
   */
  loadOverseaPortDestinationAgent() {
    // isClearDestinationAgent = false
    // loadOverseaAgentPort()
  }
  async loadOverseaAgentPort() {
    if (this.dischargingPortIsDirty && this.isJoinPortDestinationAgent) {
      this.view.overseaAgentDataProviderChange = true
      const job = this.job
      await new SeaExportJob(job).getOverseaAgentPort(job.lob, job.dischargingPortCode)
      const overseaAgentPortList = job.overseaAgentPort
      const array = []
      if (overseaAgentPortList && overseaAgentPortList.length > 0) {
        for (const overseaAgentPort of overseaAgentPortList) {
          if (overseaAgentPort.agent && overseaAgentPort.agent.company && array.indexOf(overseaAgentPort.agent.company) < 0) {
            array.push(overseaAgentPort.agent.company)
          }
        }
        if (this.isClearDestinationAgent) {
          job.destinationAgent = 0
          job.designationAgent = 0
        }
        // 指定货代理
        this.designationAgentArray = array
        // 目的港代理
        this.destinationAgentArray = array
        this.dischargingPortIsDirty = false
      }
    }
  }

  /**
   * 加载指定货代理
   */
  loadOverseaAgentDetail() {
    const job = this.job
    if (job.designationAgent > 0) {
      const company = this.companyList.find(p => p.cmpIdx === job.designationAgent)
      if (company) {
        this.loadOverSeaResultHandler()
      }
    }
  }
  /**
   * 指定货代理 销售处显示网管名字。
   */
  loadOverSeaResultHandler(event = null) {
    if (this.job.designationAgent > 0) {
      this.loadOverseaAgentDetailOwner(this.job.designationAgent)
    }
  }
  /**
   * 指定货 -> 加载网管
   */
  async loadOverseaAgentDetailOwner(companyId) {
    this.ownerCompanyId = companyId
    const company = this.companyList.find(p => p.cmpIdx === companyId)
    if (company) {
      const overseaAgentDetail = await new Company(company).getOverseaAgentDetail()
      this.loadOverseaAgentDetailOwnerHandler(overseaAgentDetail)
    }
  }
  loadOverseaAgentDetailOwnerHandler(overseaAgentDetail) {
    const data = { value: 0 }
    if (overseaAgentDetail) {
      // 添加指定货代理等级
      const overseaAgentGrade = OverseaAgentGrade.getOverseaAgentGradeByCode(overseaAgentDetail.grade)
      if (overseaAgentGrade) {
        this.job.agentLevel = overseaAgentGrade.chineseName
      }
      const user = this.userList.find(p => p.userId === overseaAgentDetail.owner)
      if (user) {
        if (this.view.salesOfficeCheck) {
          if (user.active) {
            Object.assign(data, user)
            data.value = overseaAgentDetail.owner
          }
        } else {
          Object.assign(data, user)
          data.value = overseaAgentDetail.owner
        }
      }
    }
    this.salesChangeHandler(data)
  }
  /**
   * 加载客户类型
   */
  async showCustomerDetail() {
    const job = this.job
    const company = this.companyList.find(p => p.cmpIdx === job.customerId)
    if (company) {
      const customerDetail = await new Company(company).getCustomerDetail()
      if (customerDetail) {
        this.lockInCargoSource(customerDetail)
      }
    }
  }
  /**
   * 是否锁定揽货类型
   */
  lockInCargoSource(customerDetail) {
    this.view.cargoSourceEnabled = this.view.isEdit
    if (!(customerDetail.designated && customerDetail.seftCanvass)) {
      if (customerDetail.designated || customerDetail.seftCanvass) {
        if (this.customerLockInCargoSource && this.view.isEdit) {
          this.view.cargoSourceEnabled = false
        }
      }
    }
  }
  async loadCustomerPortDestinationAgents(allowPopup = false) {
    if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        await new Company(company).getCustomerDetail()
        this.loadCustomerDetail1Handler(company.customerDetail, allowPopup)
      }
    }
  }
  async loadCustomerDetail1Handler(customerDetail, allowPopup = false) {
    if (customerDetail) {
      const portDestinationAgents = await new Customer(customerDetail).getPortDestinationAgents()
      this.loadPortDestinationAgentsHandler(portDestinationAgents, allowPopup)
    }
  }
  loadPortDestinationAgentsHandler(portDestinationAgents, allowPopup = false) {
    if (portDestinationAgents) {
      const job = this.job
      // 判断是否只维护了一个指定货代理且目的港为空,如果仅维护一个，则所有的目的港指定货代理取值维护的指定货代理
      let isOnlyPortDestinationAgent = false
      let defaultPortDestinationAgent = null
      if (portDestinationAgents && portDestinationAgents.length === 1) {
        defaultPortDestinationAgent = portDestinationAgents[0]
        if (!defaultPortDestinationAgent.destinationPort) {
          isOnlyPortDestinationAgent = true
        }
      }
      // 判断当前业务的指定货代理是否为空
      if (!job.designationAgent || Number(job.designationAgent) === 0) {
        if (portDestinationAgents.length === 1) {
          if (isOnlyPortDestinationAgent) {
            if (defaultPortDestinationAgent.defaultAgent) {
              this.updatePortDestinationAgentInformation(defaultPortDestinationAgent)
            }
          } else {
            if (job.dischargingPortCode === defaultPortDestinationAgent.destinationPort && defaultPortDestinationAgent.defaultAgent) {
              this.updatePortDestinationAgentInformation(defaultPortDestinationAgent)
            }
          }
        } else {
          // 现根据卸货港去匹配，匹配不到取默认指定货代理
          let isFind = false
          if (portDestinationAgents && portDestinationAgents.length > 0) {
            for (const a of portDestinationAgents) {
              if (job.dischargingPortCode === a.destinationPort && a.defaultAgent) {
                isFind = true
                this.updatePortDestinationAgentInformation(a)
                break
              }
            }
            // 取默认的指定货代理
            if (!isFind) {
              for (const b of portDestinationAgents) {
                if (!b.destinationPort && b.defaultAgent) {
                  this.updatePortDestinationAgentInformation(b)
                  break
                }
              }
            }
          }
        }
      } else {
        // 业务中有指定货代理，判断目的港是否维护有默认的指定货代理(默认的指定货代理只有一个)
        let i = 0
        let isDefaultAgent = false
        let defaultAgent = null
        if (portDestinationAgents && portDestinationAgents.length > 0) {
          for (const a1 of portDestinationAgents) {
            if (job.dischargingPortCode === a1.destinationPort) {
              i++
              if (a1.defaultAgent) {
                defaultAgent = a1
                isDefaultAgent = true
              }
            }
          }
        }
        if (portDestinationAgents && portDestinationAgents.length >= 2) {
          for (const a2 of portDestinationAgents) {
            if (!a2.destinationPort) {
              isOnlyPortDestinationAgent = true
            }
          }
        }
        if (i === 0 && job.designationAgent && job.dischargingPortCode && !isOnlyPortDestinationAgent) {
          const callback = () => {
            job.designationAgent = 0
            this.loadOverseaAgentDetailOwner(0)
            this.view.txtSalesOffice = ''
            job.sales = 0
            job.salesDepartment = 0
            this.dipatchChangedSalesEvent(0)
          }
          // CARGO-15388 H5 更新委托单位后，指定货代理自动消失
          // if (allowPopup) {
          this.view.$confirm(this.view.$t('SeaExport.UnloadingPortNotMaintain'), this.view.$t('common.tips.prompt'), {
            confirmButtonText: this.view.$t('common.btn.ok'),
            cancelButtonText: this.view.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            callback()
          }).catch(() => { })
          // } else {
          //   callback()
          // }
        }

        if (job.dischargingPortCode) {
          if (isDefaultAgent) {
            if (job.designationAgent !== defaultAgent.destinationAgentId) {
              if (allowPopup) {
                this.view.$confirm(this.view.$t('SeaExport.PortMaintainedDesignatedFreightForwarder'), this.view.$t('common.tips.prompt'), {
                  confirmButtonText: this.view.$t('common.btn.ok'),
                  cancelButtonText: this.view.$t('common.btn.cancel'),
                  closeOnClickModal: false,
                  type: 'warning'
                }).then(() => {
                  this.updatePortDestinationAgentInformation(defaultAgent)
                }).catch(() => { })
              } else {
                this.updatePortDestinationAgentInformation(defaultAgent)
              }
            }
          } else {
            if (portDestinationAgents && portDestinationAgents.length > 0) {
              for (const c of portDestinationAgents) {
                if (!c.destinationPort && c.defaultAgent) {
                  this.updatePortDestinationAgentInformation(c)
                  break
                }
              }
            }
          }
        }
      }
    }
  }
  /**
   * 更新指定货代理以及销售栏位等信息
   */
  updatePortDestinationAgentInformation(agent) {
    const job = this.job
    job.designationAgent = agent.destinationAgentId
    CargoDocUtil.changeHBLAgentParty(job)
    // 指定货带网管
    this.loadOverseaAgentDetailOwner(job.designationAgent)
    if (job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) { // 如果是指定货
      this.loadOverseaAgentUserByLob(job.designationAgent)// 根据指定货确定海外客服
    } else {
      this.loadOverseaAgentUserByLob(job.destinationAgent)// 还是根据目的港代理确定海外客服
    }
  }
  /**
   * 关账后，基本页面里的销售公司、销售员、操作部门不允许修改
   */
  checkWithinClosingAccountDate() {
    ClosingAccount.isContainClosedCharge(this.context.office.officeId, this.job.jobNo).then(res => {
      this.isWithinCloseAccountDate = Boolean(res.data)
    })
  }
  /**
   * 是否跨tenant委托
   */
  checkIsCrossTenant() {
    const job = this.job
    if (job.customerId > 0) {
      const company = this.companyList.find(p => p.cmpIdx === job.customerId)
      if (company) {
        const relatedTenant = company.relateTenantId
        this.isCrossTenant = job.trustFromJob && relatedTenant > 0
      }
    }
  }
  /**
   * 根据整拼类型自动获取对应的自定义业务类型，如果有多个默认选中第一个
   */
  selectDefaultCutomJobType() {
    const options = this.cutomJobTypeList.filter(p => p.type === this.job.lob && p.containerLoadType === this.job.containerLoadType)
    if (options.length > 0) {
      this.job.customJobType = options[0].code
    }
  }
  /**
   * 箱型信息控制
   */
  async seaEqDateCl() {
    const job = this.job
    if (!job) return
    let eq = null
    await new SeaExportJob(this.job).getSeaEQ()
    if (job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
      if (job.seaEQ.length === 0) {
        eq = new SeaEQ().fillDefaultValue().getData()
        eq.eqType = 'GP'
        eq.eqSize = '20'
        eq.eqQuantity = 1
        eq.jobUuid = job.uuid
        job.seaEQ.push(eq)
        ContainerUtil.autoJustContainerUsages(job)
      }
      this.view.seaEqList = job.seaEQ
    } else if (job.containerLoadType !== ContainerLoadType.FCL_CARGO_TYPE.code && job.containerLoadType !== ContainerLoadType.SPECIAL_CARGO_TYPE.code && job.containerLoadType !== ContainerLoadType.BC_CARGO_TYPE_FCL.code && job.seaEQ && job.seaEQ.length > 0) {
      job.seaEQ = []
    }
    if ((job.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code) && job.seaEQ && job.seaEQ.length > 0) {
      const seaEqs = job.seaEQ
      for (let j = seaEqs.length - 1; j >= 0; j--) {
        const seaEq = seaEqs[j]
        seaEq.sizeHeight = 0.0
        seaEq.sizeLength = 0.0
        seaEq.sizeWidth = 0.0
      }
    }
    if (job.containerLoadType !== ContainerLoadType.BULK_CARGO_TYPE.code && job.cargoBulkDetails && job.cargoBulkDetails.length > 0) {
      await new SeaExportJob(job).getCargoBulkDetail()
      const details = job.cargoBulkDetail
      for (let k = details.length - 1; k >= 0; k--) {
        const cd = details[k]
        cd.jobUuid = null
      }
      job.insideQuantitySize = 0.0
    }
  }
  /**
   * 客户特殊要求
   */
  getRequestSelectedKeys() {
    // return view.selectedSpecialRequest.getRequestSelectedKeys()
  }
  /**
   * 计费重量修改计算
   */
  async calculateChargeWeight() {
    try {
      let weight = this.chargeWeightCalculationMode === 1 ? parseFloat(this.job.weightContract) : parseFloat(this.job.weightActual)
      const cubage = this.chargeWeightCalculationMode === 1 ? parseFloat(this.job.cubageContract) : parseFloat(this.job.cubageActual)
      let chargeFlag = false
      if (isNaN(weight) || isNaN(cubage)) return
      weight = weight / 1000
      if (cubage > weight) {
        weight = cubage
      }
      if (weight > 0 && weight < 1) {
        weight = 1.00
      }
      this.job.chargeWeight = parseFloat(weight.toFixed(3))
      for (const charge of this.job.charges) {
        if (!charge.confirmBillUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code) {
          chargeFlag = true
          break
        }
      }
      if (chargeFlag) {
        this.view.$confirm(this.view.$t('Message.TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated'), {
          confirmButtonText: this.view.$t('common.btn.ok'),
          cancelButtonText: this.view.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of this.job.charges) {
            if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
              !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code &&
              !charge.verifiedAmount && !charge.paidOff) {
              charge.quantity = this.job.chargeWeight
              if (charge.unitPriceIncludeTax) {
                ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              } else {
                ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
              }
            }
          }
        }).catch(() => {
        }).finally(() => {
        })
      }
      this.txtCubageActualFocusOutHandler(this.job.cubageActual)
      await this.changeSynBillOfLadingQWC()
    } catch (e) {
      // console.log('calculateChargeWeight error', e)
    }
  }
  async changeSynBillOfLadingQWC() {
    await CargoDocUtil.changeSynBillOfLadingQWC(this.job, this.job.quantityActual, this.job.weightActual, this.job.cubageActual)
  }
  // 委托件毛体 更改事件 @change 事件中的 委托的 件毛体赋值 在此之后 导致 装箱数据仍是上一次的值
  async jobContractQwcChange(type) {
    if (type === 1) {
      await SEUtils.changeQWCRule(() => {
        this.job.quantityActual = this.job.quantityContract
      })
      await this.changeSynBillOfLadingQWC()
      await this.txtPackingChangeHandler()
    } else if (type === 2) {
      await SEUtils.changeQWCRule(() => { this.job.weightActual = this.job.weightContract })
      await this.calculateChargeWeight()
    } else if (type === 3) {
      await SEUtils.changeQWCRule(() => { this.job.cubageActual = this.job.cubageContract; this.job.chargeWeight = this.job.cubageContract })
      await this.calculateChargeWeight()
    }

    this.refContainerUsageQwc(2, true)
  }

  refContainerUsageQwc(viewPager = 0, btnSave = true) {
    ContainerUtil.refContainerUsageQwc(this.job, viewPager, btnSave)
  }
  /**
   * 正本打印锁定业务页签
   */
  async lockBookingTab() {
    const job = this.job
    const hbl = await new SeaExportJob(job).getMainHbl()
    job.printHblZbLock = false
    const isLockTab = await parseInt(this.config.get('HBLPrintLockTab')) === 1
    if (hbl) {
      job.printHblZbLock = (hbl.state === 2 && isLockTab)
    }
  }
  /**
   * 拼箱小票，不允许编辑：目的港代理、船名、航次、订舱单位、船公司、主单运费条款、卸货港
   */
  lclslaveEnabledCl() {
    this.lclslaveEnabled = this.view.isEdit
    if (this.lclslaveEnabled && this.job && this.job.lclMasterUuid) {
      this.lclslaveEnabled = false
    }
  }
  /**
   * 散杂货时，主分单运输条款默认为空
   */
  selectFreightTermByBulkCargo() {
    const job = this.job
    if (!job.uuid && job.containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code) {
      job.freightTerm = ''
      job.freightTermHBL = ''
    } else {
      // CARGO-8139 海出【委托拼箱】基本页签增加“主单运输条款”默认为CFS-CFS qm
      if (job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code) {
        if (!job.uuid || !job.freightTerm) {
          job.freightTerm = 'CFS-CFS'
        }
      }
      if (!job.freightTerm) {
        job.freightTerm = 'CY-CY'
      }
      if (!job.freightTermHBL) {
        job.freightTermHBL = 'CY-CY'
      }
    }
  }
  ETDEditChange() {
    this.view.etdEnabled = this.view.isEdit
    if (this.job.actualUnBerthPlanDate) {
      const isChangeETD = (parseInt(this.config.get('isChangeETD')) === 1)
      if (isChangeETD) {
        this.view.etdEnabled = false
      }
    }
  }
  sopConfig() {
    this.view.sopImageA = false
    this.view.sopImageB = false
    this.view.sopImageC = false
    SopPushConfig.findByOfficeId(this.context.office.officeId).then(data => {
      this.configSuccessHandler(data.sopPushConfig)
    })
  }
  configSuccessHandler(sop) {
    console.log('configSuccessHandler')
    if (sop) {
      this.view.sopConfigOpen = sop.ifAuto
      if (this.view.creditOpen) {
        this.checkCredit()
      } else if (this.view.sopConfigOpen) {
        const designationAgent = this.companyList.find(p => p.cmpIdx === this.job.designationAgent)
        this.view.sopImageA = designationAgent && designationAgent.ifOpenSop

        const customer = this.companyList.find(p => p.cmpIdx === this.job.customerId)
        this.view.sopImageB = customer && customer.ifOpenSop

        const destinationAgent = this.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
        this.view.sopImageC = destinationAgent && destinationAgent.ifOpenSop
      }
    } else {
      this.checkCredit()
    }
  }
  sopChangeBookingAgentHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.designationAgent) {
      this.view.$message.warning(this.view.$t('SeaExport.ChooseDesignatedAgent'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.designationAgent, 'DesignationAgent').then(data => {
      this.pageAResultHandler(data)
    })
  }
  sopChangeCustomerIdHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.customerId) {
      this.view.$message.warning(this.view.$t('SeaExport.PleaseSelectTheEntrustingCompany'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.customerId, 'customer').then(data => {
      this.pageBResultHandler(data)
    })
  }
  sopChangeHandler() {
    if (this.view.isEdit) {
      return
    }
    const job = this.job
    if (!job.destinationAgent) {
      this.view.$message.warning(this.view.$t('SeaExport.PleaseSelectDestinationAgent'))
      return
    }
    if (!job.uuid) {
      return
    }
    SopEmailReceiver.queryJobSopReceiver(job.uuid, job.destinationAgent, 'DestinationAgent').then(data => {
      this.pageCResultHandler(data)
    })
  }
  pageAResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.designationAgent, 'DesignationAgent')
  }
  pageBResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.customerId, 'customer')
  }
  pageCResultHandler(contactList) {
    this.pageResultHandler(contactList, this.job.destinationAgent, 'DestinationAgent')
  }
  pageResultHandler(contactList, cmpIdx, agent) {
    this.view.sopDialog.cmpIdx = cmpIdx
    this.view.sopDialog.agent = agent
    this.view.sopDialog.contactList = contactList
    this.view.sopDialog.resultFunction = value => {
      this.saveSop(value, agent)
    }
    this.view.sopDialog.visible = true
  }
  saveSop(value, agent) {
    if (agent) {
      const job = this.job
      switch (agent) {
        case 'customer':
          job.ifPushSop = value
          break
        case 'DestinationAgent':
          job.ifPushSopM = value
          break
        case 'DesignationAgent':
          job.ifPushSopZ = value
          break
        case 'PortOfLoadingAgent':
          job.ifPushSopQ = value
          break
      }
    }
  }
  /**
   * type代表不同的角色
   */
  checkCreditByCompany(companyId, type) {
    const callback = credit => {
      let checkCredit = false
      const company = this.context.companyList.find(p => p.cmpIdx === companyId)
      if (credit) {
        let tip = ''
        if (credit.amountExceeded || credit.dateExceeded) {
          const config = this.getCreditEDISetting()
          if (config.booking) {
            if (credit.amountExceeded) { tip += this.view.$t('CargoMsg.Cargo_Limit') }
            if (credit.dateExceeded) { tip += this.view.$t('CargoMsg.Cargo_AccountPeriod') }
            if (tip) {
              const toolTip = this.view.$t('CargoMsg.Cargo_Parter') + tip + this.view.$t('SeaExport.HasExceeded')
              if (type === 1) {
                // CARGO-51448 当信控超期时候，如果也配置了SOP推送，则将SOP推送的图标也展示出来
                this.view.showWarningImageB = true
                if (company && company.ifOpenSop && this.sopConfigOpen) {
                  this.view.sopImageB = true
                }
                this.view.warningImageBTip = toolTip
              } else if (type === 2) {
                this.view.showWarningImageA = true
                this.view.warningImageATip = toolTip
              } else if (type === 3) {
                this.view.showWarningImageC = true
                this.view.warningImageCTip = toolTip
              }
              checkCredit = true
            }
          }
        }
      }
      if (!credit || !checkCredit) {
        if (company && company.ifOpenSop && this.sopConfigOpen) {
          if (type === 1) {
            this.view.showWarningImageB = false
            this.view.sopImageB = true
          } else if (type === 2) {
            this.view.showWarningImageA = false
            this.view.sopImageA = true
          } else if (type === 3) {
            this.view.showWarningImageC = false
            this.view.sopImageC = true
          }
        }
      }
    }
    checkCreditInfo({ [companyId]: companyId }, CreditInfoUtil.getJobData(this.job)).then(res => {
      for (const item of res.data) {
        callback(item)
      }
    })
  }
  getCreditEDISetting() {
    const setting = this.config.get('creditBlockEDI')
    const a = setting.split(',')
    const r = {}
    for (const o of a) {
      let lock = false
      if (o.split('-')[1] === '1') {
        lock = true
      }
      r[o.split('-')[0]] = lock
    }
    return r
  }
  // 设置航线负责人
  setPlannerChange() {
    if (this.view.isEdit) {
      const job = this.job
      const port = this.seaPortList.find(p => p.code === job.dischargingPortCode)
      if (port) {
        const region = this.regionList.find(p => p.code === port.region)
        if (region && region.plannerList) {
          const pList = region.plannerList.split(',')
          let p = 0
          for (const u of pList) {
            const t = u.split('-')
            if (t.length === 2 && (t[0] === 'SE' || t[0] === 'ALL')) {
              p = Number(t[1]) || 0
            } else {
              p = Number(t[0]) || 0
            }
            if (p) {
              break
            }
          }
          if (p > 0) {
            job.planner = p
          }
          if (job.planner !== 0) {
            getUserDefaultDepartment({
              category: 'role',
              shape: 'seaLine',
              userId: job.planner,
              officeId: this.context.office.officeId
            }).then(res => {
              this.getPlannerResult(res.data)
            })
          }
        }
      }
    }
  }
  // 获取合约状态
  getContractStatus(company) {
    this.view.stampPictureView.businessDocuments = []
    if (!company) return
    getContractsByCompanyUuids([company.uuid]).then(async res => {
      const contracts = res.data
      if (contracts && contracts.length > 0) {
        const now = moment()
        const businessIds = []
        for (const item of contracts) {
          // 过滤出当前合作伙伴所有未到期的合同
          if (dateCompareYMD(item.endDate, now) >= 0) {
            businessIds.push(item.uuid)
          }
        }
        if (businessIds.length > 0) {
          findBusinessDocument({ businessIds: businessIds }).then(res => {
            const docs = res.data
            if (docs && docs.length > 0) {
              const useDocs = []
              for (const doc of docs) {
                if (!doc.fileCategory || doc.fileCategory !== 'STAMP') continue
                if (!doc.fileType || !SystemConstants.IMAGES.includes(doc.fileType.toUpperCase())) continue
                useDocs.push(doc)
              }
              this.view.stampPictureView.businessDocuments = useDocs
            }
          })
        }

        company.contractStatus = businessIds.length > 0 ? 2 : 1
        // if (contracts.find(p => dateCompare(p.endDate, now) > 0)) {
        //   company.contractStatus = 2 // 已签约
        // } else {
        //   company.contractStatus = 1 // 合约失效
        // }
      } else {
        company.contractStatus = 0 // 未签约
      }
      const contractState = this.view.contractStatuses[company.contractStatus]
      this.view.contractStatus = company.contractStatus
      this.view.contractStatusLabel = contractState ? contractState.label : ''
      this.view.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.view.form))
    })
  }
  async selectWindowHandler(value) {
    this.job.chargeWeight = 0
    const lclJob = await new SeaExportJob(this.job).batchCloneLcLJob()
    console.log(lclJob)
    lclJob.lclMasterUuid = this.job.uuid
    lclJob.lclMaster = this.job
    lclJob.lclNumber = value
    this.view.$emit('addLcl', lclJob)
  }
  async slavedAddedHandler(rows) {
    this.context.loading = true
    try {
      await batchAddJob(rows, this.job.uuid, this.job.mbl, this.view.location).then(res => {
        const result = res.data
        if (result && result.length > 0) {
          for (const selectSlave of rows) {
            for (const slave of result) {
              if (selectSlave.uuid === slave.uuid) {
                slave.soNo = selectSlave.soNo
              }
            }
          }
          this.view.rowData.push(...result)
          this.view.gridApi.setRowData(this.view.rowData)
          this.view.$emit('addSlavedJob', res.data)
          this.refreshLclMaster(this.job)
        }
      })
      await this.updateJMT()
    } finally {
      this.context.loading = false
    }
  }
  async btnRemoveBatchClickHandler() {
    const selectedItems = this.view.gridApi.getSelectedRows()
    if (selectedItems.length === 0) {
      throw new ErrorTip(this.view.$t('SeaExport.UncheckedSmallTicket'), 'info')
    }
    for (const subJob of selectedItems) {
      await new SeaExportJob(subJob).getContainerUsages()
      if (subJob.quantityActual !== this.getItemLeft(subJob) || subJob.weightActual !== this.getWeightLeft(subJob) ||
          subJob.cubageActual !== this.getCubageLeft(subJob)) {
        throw new ErrorTip(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
      }
      for (const c of subJob.containerUsages) {
        if (c.container && c.container.jobUuid && c.container.jobUuid === this.job.uuid) {
          throw new ErrorTip(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
        }
      }
      if (!await SecurityUtil.canOPEditWithAlert(subJob)) {
        return
      }
    }
    this.removedSubJobs = selectedItems
    const jobKeys = Array.from(selectedItems, p => p.uuid)
    await checkJobForShared(jobKeys).then(async res => {
      if (res.data) {
        this.view.$message.warning(res.data + this.view.$t('CargoMsg.Cargo_SmallTicketCannotBeRemoved'))
      } else {
        const loading = getLoading4Cxt(this.view)
        batchRemoveJob(jobKeys, this.view.location).then(res => {
          this.onSaveBatchSucceeded(res.data)
          this.view.gridApi.updateRowData({ 'remove': selectedItems })
        }).finally(() => {
          loading.close()
        })
      }
    })
  }
  onSaveBatchSucceeded(num) {
    if (num > 0) {
      this.job.lclSlaves = ''
      new SeaExportJob(this.job).getLclSlaves().then(data => {
        this.refreshLclMaster(this.job)
      })
      const jobKeys = Array.from(this.removedSubJobs, p => p.uuid)
      this.view.$emit('removeJobFromMaster', jobKeys)
      this.updateJMT()
    }
  }
  async refreshLclMaster(seJob) {
    if (!seJob) {
      return
    }
    if (!this.view.isEdit) {
      this.job.seaCargoDoc = ''
      this.job.cargoDoc = ''
      return
    }
    const mbl = await new SeaExportJob(this.job).getMainMbl()
    if (mbl) {
      CargoDocUtil.changeJobSynToBillOfLading(seJob, mbl)
      mbl.quantitySum = this.getQuantitySum(mbl.quantity, mbl.packing)
    }
    const hbl = await new SeaExportJob(this.job).getMainHbl()
    if (hbl) {
      CargoDocUtil.changeJobSynToBillOfLading(seJob, hbl)
      mbl.quantitySum = this.getQuantitySum(hbl.quantity, mbl.packing)
    }
  }
  getQuantitySum(quantity, packingCode) {
    const options = this.context.packingList.filter(p => p.code === packingCode)
    if (options.length === 0) {
      return
    }
    let packing = options[0].name
    switch (packing) {
      case 'CTNS':
        packing = 'CARTONS'
        break
      case 'BALE':
        if (quantity !== 1) {
          packing = 'BALES'
        }
        break
      case 'PCS':
        packing = 'PIECES'
        break
    }
    return 'SAY ' + quantity + packing + ' ONLY.'
  }
  async updateJMT() {
    await getSeaExportJobByUuid(this.job.uuid).then((res) => {
      const result = res.data ? res.data : null
      if (result) {
        this.job.quantityActual = result.quantityActual
        this.job.weightActual = result.weightActual
        this.job.cubageActual = result.cubageActual
        this.job.quantityContract = result.quantityContract
        this.job.weightContract = result.weightContract
        this.job.cubageContract = result.cubageContract
        this.job.chargeWeight = result.chargeWeight
      }
    })
  }
  getItemLeft(input) {
    let quantity = input.quantityActual
    for (const usage of input.containerUsages) {
      quantity = quantity - usage.quantity
    }
    return quantity
  }
  getWeightLeft(input) {
    let weight = input.weightActual
    if (isNaN(weight)) {
      weight = 0.0
    }
    for (const usage of input.containerUsages) {
      let usedWeight = usage.weight
      if (isNaN(usedWeight)) {
        usedWeight = 0.0
      }
      weight = weight - usedWeight
    }
    return weight
  }
  getCubageLeft(input) {
    let cubage = input.cubageActual
    if (isNaN(cubage)) {
      cubage = 0.0
    }
    for (const usage of input.containerUsages) {
      let usedCubage = usage.cubage
      if (isNaN(usedCubage)) {
        usedCubage = 0.0
      }
      cubage = cubage - usedCubage
    }
    return cubage
  }
  validateDelJobResultHandler(obj) {
    if (obj.hasOwnProperty('status')) {
      this.view.$confirm(this.view.$t('Message.SureDelete'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('common.btn.ok'),
        cancelButtonText: this.view.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        if (!this.view.selectedRow) return
        this.removeSubJob = this.view.selectedRow
        batchDeleteJob({ jobKeys: [this.removeSubJob.uuid], location: this.view.location }).then(res => {
          this.delJobResultHandler(res.data)
        })
      }).catch(() => { })
    } else {
      throw new ErrorTip(obj.msg)
    }
  }
  delJobResultHandler(num) {
    if (num > 0) {
      this.view.$message.success(this.view.$t('Message.DeleteSuccessfully'))
      const index = this.view.rowData.findIndex(p => this.removeSubJob && p.uuid === this.removeSubJob.uuid)
      if (index > -1) {
        this.view.rowData.splice(index, 1)
        this.view.gridApi.setRowData(this.view.rowData)
        this.view.selectedRowIndex = -1
        this.view.gridApi.clearFocusedCell()
      }
      this.view.$emit('removeJob', this.removeSubJob.uuid)
      this.refreshLclMaster(this.job)
    }
  }

  async cargoSalesChargeHandler(data) {
    const job = this.job
    job.cargoSalesId = data.value || 0
    job.cargoSalesDepartment = 0
    job.cargoSalesOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.cargoSalesOffice = office ? office.officeId : 0
            job.cargoSalesDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'salesOfGoods')
        if (department) {
          job.cargoSalesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          job.cargoSalesOffice = office ? office.officeId : 0
        }
      }
    }
  }
  // 选择揽货类型带出合作伙伴对应的服务人员【单证】【客服】【自定义岗位1】【自定义岗位2】
  loadCompanyUserByCargoSource() {
    if (this.isSpecifiedSalesBusiness && this.job.cargoSource) {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          const companyUsers = data.filter(p => (p.cargoSource === this.job.cargoSource || !p.cargoSource))
          this.loadCompanyUserByCargoSourceHandler(companyUsers)
        })
      }
    }
  }
  async loadCompanyUserByCargoSourceHandler(companyUsers) {
    const job = this.job
    // 客服
    const csrList = []
    // 对应揽货类型的客服
    const csrCargoSourceList = []
    let csrDefaultId = 0
    // 单证
    const dcList = []
    // 对应揽货类型的单证
    const dcCargoSourceList = []
    let dcDefaultId = 0
    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        if (u.lob === 'SE' || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.CSR_TYPE.code) { // 客服
              if (u.defaultUser) {
                csrDefaultId = u.userId
              }
              if (u.cargoSource === this.job.cargoSource) {
                csrCargoSourceList.push(user)
              } else {
                csrList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.DOC_TYPE.code) { // 单证
              if (u.defaultUser) {
                dcDefaultId = u.userId
              }
              if (u.cargoSource === this.job.cargoSource) {
                dcCargoSourceList.push(user)
              } else {
                dcList.push(user)
              }
            }
          }
        }
      }
    }
    // 客服
    if (csrCargoSourceList.length > 0) {
      job.csr = csrCargoSourceList[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.csr)
        this.csrChangeHandler({ ...user, value: user.userId })
      })
    } else if (csrList.length > 0) {
      if (csrDefaultId > 0) {
        job.csr = csrDefaultId
      } else {
        job.csr = csrList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.csr)
        this.csrChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.csr = 0
      // job.csrDepartment = 0
      // job.csrOffice = 0
    }
    // 单证
    if (dcCargoSourceList.length > 0) {
      job.dc = dcCargoSourceList[0].userId
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.dc)
        this.dcChangeHandler({ ...user, value: user.userId })
      })
    } else if (dcList.length > 0) {
      if (dcDefaultId > 0) {
        job.dc = dcDefaultId
      } else {
        job.dc = dcList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.dc)
        this.dcChangeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.dc = 0
      // job.dcDepartment = 0
      // job.dcOffice = 0
    }
  }
  /**
	 * 起运港修改
	 */
  async loadingPortCodeChange(data) {
    await super.loadingPortCodeChange(data)
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, warehouseId => this.warehouseCmpChangeHandler({ value: warehouseId }), false, null, this.context.modifiedData)
    JobUtils.loadingShipDate(this.job)
  }
}
